export const PAID_ORDERS_LIST_KEY = 'PAID_ORDERS_LIST';
export const PAID_ORDERS_ONE_KEY = 'PAID_ORDERS_ONE_KEY';
